import React, { useState, useMemo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { useTelegram } from "../hooks/useTelegram";
import { CartIcon } from "./GetIcons";
import "swiper/css";
import "./GameSlider.scss";

const GameSlider = ({
	banners,
	cartItems,
	handleRemoveFromCart,
	handleAddToCart,
	handleGameItemClick,
}) => {
	const { triggerHapticFeedback, tg } = useTelegram();
	const [imageIndex, setImageIndex] = useState(0);

	const filePath = process.env.REACT_APP_FILE_PATH;

	const allItems = useMemo(() => {
		if (!banners || banners.length === 0) return [];
		return banners.flatMap((game) => game.items);
	}, [banners]);

	const formatCurrency = (number) => {
		return (
			new Intl.NumberFormat("ru-RU", {
				currency: "RUB",
				minimumFractionDigits: 2,
			}).format(number) + " руб"
		);
	};

	const formatCurrencyDisc = (number) => {
		return new Intl.NumberFormat("ru-RU", {
			currency: "RUB",
		}).format(number);
	};

	if (allItems.length === 0) {
		return <div className="gameSlider-empty">Нет товаров</div>;
	}

	const handleAdd = (item) => {
		triggerHapticFeedback("impact", "medium");
		handleAddToCart(item);
	};

	const handleRemove = (item) => {
		triggerHapticFeedback("impact", "medium");
		handleRemoveFromCart(item);
	};

	const openItem = (item) => {
		triggerHapticFeedback("impact", "medium");
		handleGameItemClick(item);
	};

	return (
		<Swiper
			slidesPerView="auto"
			spaceBetween={20}
			onSlideChange={(swiper) => setImageIndex(swiper.activeIndex)}
			loop={false}
			className="gameSlider"
		>
			{allItems.map((item, index) => {
				const cartItem = cartItems.find(
					(cartItem) => cartItem.itemId === item.itemId,
				);

				return (
					<SwiperSlide key={item.itemId || index} className="gameSlide">
						<div className="gameSlide-inner">
							<img
								src={`${filePath}/Games/${item.fileName}`}
								alt={item.title || item.name}
								className="slideImage"
								onClick={() => openItem(item)}
							/>

							<div className="gameSliderText" onClick={() => openItem(item)}>
								<h3>
									{item.parentFileName && (
										<img
											src={`${filePath}/Games/${item.parentFileName}`}
											alt={item.parentName}
										/>
									)}
									{item.name}
								</h3>

								<div>
									<p>
										<span className="price-text">
											{formatCurrency(item.priceAfterDiscount)}
										</span>
										{item.discount > 0 && (
											<span className="discounted">
												{formatCurrencyDisc(item.price)}
											</span>
										)}
									</p>
									{item.discount > 0 && (
										<span className="disc">-{item.discount}%</span>
									)}
								</div>
							</div>

							{cartItem ? (
								<div className="gameSliderBtnDiv">
									<div className="gameSliderButtons">
										<button onClick={() => handleRemove(item)}>-</button>
									</div>
									<p className="quantity">{cartItem.quantity}</p>
									<div className="gameSliderButtons">
										<button onClick={() => handleAdd(item)}>+</button>
									</div>
								</div>
							) : (
								<div className="gameSliderBtn">
									<button onClick={() => handleAdd(item)}>
										В Корзину
										<CartIcon fillColor="#FFAA00" />
									</button>
								</div>
							)}
						</div>
					</SwiperSlide>
				);
			})}
		</Swiper>
	);
};

export default GameSlider;
